// Azzurro vocabulary expansion — HOUSE & HOME theme (net-new cards).
//
// Extends the `house` blocks in ./vocabulary.js without reusing any headword
// already defined there. Seed upserts on `spanish`, so every value is unique.
//   [ italian, english, emoji, part_of_speech, gender, example_it, example_en ]

export const VOCAB_HOUSE = [
  {
    theme: "house", tier: "A1", rows: [
      ["la stanza", "room", "🚪", "noun", "f", "La mia stanza è piccola.", "My room is small."],
      ["la parete", "wall", "🧱", "noun", "f", "La parete è bianca.", "The wall is white."],
      ["lo specchio", "mirror", "🪞", "noun", "m", "Mi guardo allo specchio.", "I look at myself in the mirror."],
      ["la chiave", "key", "🔑", "noun", "f", "Non trovo la chiave.", "I can't find the key."],
      ["il piatto", "plate", "🍽️", "noun", "m", "Il piatto è sporco.", "The plate is dirty."],
      ["il bicchiere", "glass", "🥛", "noun", "m", "Voglio un bicchiere d'acqua.", "I want a glass of water."],
      ["la luce", "light", "💡", "noun", "f", "Spegni la luce, per favore.", "Turn off the light, please."],
      ["la doccia", "shower", "🚿", "noun", "f", "La doccia è rotta.", "The shower is broken."],
      ["pulire", "to clean", "🧽", "verb", "", "Pulisco la casa il sabato.", "I clean the house on Saturdays."],
      ["il piano terra", "ground floor", "🏢", "phrase", "", "Abito al piano terra.", "I live on the ground floor."],
    ],
  },
  {
    theme: "house", tier: "A2", rows: [
      ["il mobile", "piece of furniture", "🪑", "noun", "m", "Abbiamo comprato un mobile nuovo.", "We bought a new piece of furniture."],
      ["il tappeto", "rug / carpet", "🧶", "noun", "m", "Il tappeto è molto morbido.", "The rug is very soft."],
      ["la tenda", "curtain", "🪟", "noun", "f", "Tira le tende.", "Draw the curtains."],
      ["il cassetto", "drawer", "🗄️", "noun", "m", "Le chiavi sono nel cassetto.", "The keys are in the drawer."],
      ["il rubinetto", "tap", "🚰", "noun", "m", "Il rubinetto gocciola.", "The tap is dripping."],
      ["la presa", "plug / socket", "🔌", "noun", "f", "Non c'è una presa qui vicino.", "There's no socket nearby."],
      ["il lavandino", "sink", "🧼", "noun", "m", "Il lavandino è otturato.", "The sink is blocked."],
      ["la lavatrice", "washing machine", "🧺", "noun", "f", "Faccio la lavatrice di notte.", "I run the washing machine at night."],
      ["il forno", "oven", "🔥", "noun", "m", "Il pane è nel forno.", "The bread is in the oven."],
      ["il balcone", "terrace / balcony", "🪴", "noun", "m", "Facciamo colazione sul balcone.", "We have breakfast on the balcony."],
    ],
  },
  {
    theme: "house", tier: "B1", rows: [
      ["il padrone di casa", "landlord", "🏠", "noun", "m", "Il padrone di casa ha aumentato l'affitto.", "The landlord raised the rent."],
      ["il contratto d'affitto", "rental contract", "📄", "phrase", "", "Abbiamo firmato il contratto d'affitto.", "We signed the rental contract."],
      ["la caparra", "deposit", "💶", "noun", "f", "Ho pagato una mensilità di caparra.", "I paid a month's deposit."],
      ["l'abitazione", "housing / dwelling", "🏘️", "noun", "f", "L'abitazione è molto cara qui.", "Housing is very expensive here."],
      ["le spese", "expenses / bills", "🧾", "noun", "f", "Le spese non sono incluse.", "Bills are not included."],
      ["ristrutturare", "to renovate", "🔨", "verb", "", "Ristruttureremo la cucina.", "We're going to renovate the kitchen."],
      ["la soffitta", "attic", "🏚️", "noun", "f", "Teniamo le cose in soffitta.", "We keep things in the attic."],
      ["il seminterrato", "basement", "🕳️", "noun", "m", "Il seminterrato è umido.", "The basement is damp."],
      ["spazioso", "spacious", "📐", "adjective", "", "Il salotto è molto spazioso.", "The living room is very spacious."],
      ["il condominio", "residents' association", "👥", "phrase", "", "Paghiamo il condominio ogni mese.", "We pay the residents' fee each month."],
    ],
  },
];
